import { openPost } from "@sinch/utils/navigation";
import { isNil } from "ramda";

export interface PreviewFields {
  recipients: string[];
  subject?: string | null;
  message?: string | null;
  additionalFields?: Record<string, string>;
}

export const useEmailPreview = (previewUrl?: string) => {
  const handlePreview = ({ recipients, subject, message, additionalFields }: PreviewFields) => {
    openPost(previewUrl ?? "/admin/emailNewsletters/preview", {
      "data[EmailNewsletter][referer]": window.location.href,
      "data[EmailNewsletter][user_id]": recipients,
      "data[EmailNewsletter][subject]": subject ?? "",
      "data[EmailNewsletter][message]": message ?? "",
      ...Object.entries(additionalFields ?? []).reduce((acc, [key, item]) => {
        if (isNil(item)) {
          return acc;
        }
        return { ...acc, [`data[EmailNewsletter][${key}]`]: item };
      }, {}),
    });
  };
  return {
    openPreviewInNewTab: handlePreview,
  };
};
